import { useQuery } from "@tanstack/react-query";
import { useApi } from "@core/api";
import { useCurrentUser } from "@core/hooks/useCurrentUser";

export function useStagedOrders(options?: { fresh?: boolean }) {
  const api = useApi();
  const { user } = useCurrentUser();
  const fresh = options?.fresh ?? false;

  const query = useQuery({
    queryKey: ["stagedOrders"],
    queryFn: () => api.ListStagedOrders(),
    enabled: !!user,
    retry: false,
    staleTime: fresh ? 0 : 30_000,
    refetchOnMount: fresh ? "always" : true,
  });

  const orders = query.data ?? [];
  const inbox = orders.filter(o => o.CanSign);
  const outgoing = orders.filter(o => o.IsOutgoing && !o.CanSign);
  const inboxTotal = inbox.reduce((sum, o) => sum + (o.Total ?? 0), 0);

  return { query, inbox, outgoing, inboxTotal };
}
